import { fabric } from 'fabric';

import { isTextbox } from './util';

type CursorType = 'default' | 'crosshair' | 'move';

function selectable(o: fabric.Object): void {
    o.selectable = true;
    if (isTextbox(o)) {
        o.editable = true;
    }
}

function unselectable(o: fabric.Object): void {
    o.selectable = false;
    if (isTextbox(o)) {
        o.editable = false;
    }
}

export class ToolMode {
    public static readonly FREEDRAW = new ToolMode(
        true,
        true,
        unselectable,
        'default',
    );
    public static readonly DISABLED = new ToolMode(
        false,
        false,
        unselectable,
        'default',
    );
    public static readonly CUSTOMDRAW = new ToolMode(
        false,
        false,
        unselectable,
        'crosshair',
    );
    public static readonly SELECT = new ToolMode(
        false,
        true,
        selectable,
        'default',
        'move',
    );

    private constructor(
        private draw: boolean,
        private select: boolean,
        public readonly objectMutator: (o: fabric.Object) => void,
        private cursor: CursorType,
        private hoverCursor?: CursorType,
    ) {}

    public apply(canvas: fabric.Canvas): void {
        canvas.isDrawingMode = this.draw;
        canvas.selection = this.select;
        canvas.forEachObject(this.objectMutator);
        canvas.defaultCursor = this.cursor;
        canvas.hoverCursor = this.hoverCursor || this.cursor;
    }
}
